import { Helmet } from 'react-helmet-async';

const SITE_NAME = '트라이그라운드 스튜디오';
const SITE_URL = 'https://trygroundstudio.com';
const DEFAULT_IMAGE = `${SITE_URL}/img/og-sofa-space-01.jpg`;

function Seo({ title, description, path = '/', image = DEFAULT_IMAGE, keywords }) {
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="al:web:url" content={url} />

      <meta property="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}

export default Seo;
